import React from 'react';
import { Typography } from '@material-ui/core';
import ReactTable from 'react-table-6';
import { css } from '@emotion/core';
import { StandardBox } from '../../styles/styles';
import { filterCaseInsensitive } from '../../util/TableUtils';

const CustomBox = css`
  //TODO: re-evaluate min height. Was it necessary?
  // min-height: 350px;
  height: auto;
  width: 300px;
  color: #666666 !important;
  margin: 0 auto;
  text-align: center;
  padding: 30px;
  display: flex;
  flex-direction: column;

  padding: 0;
  margin: 0;
  .ReactTable {
    flex: 1;
    border: 0px;
  }

  .ReactTable .rt-td {
    padding: 0;
    margin: 0;
  }

  .ReactTable .rt-tr {
    flex: none;
  }

  .ReactTable .rt-tr-group {
    flex: none;
    border-bottom: none;
  }
`;

const Column = ({ dataArray, config, style }) => {
  return (
    <div css={CustomBox} style={style}>
      <ReactTable
        TheadComponent={() => <noscript />}
        showPagination={false}
        data={dataArray}
        columns={config}
        minRows={1}
        defaultPageSize={1000}
        // pageSizeOptions={[15, 25, 50, 100]}
        // filterable
        defaultFilterMethod={filterCaseInsensitive}
        noDataText=""
      />
    </div>
  );
};

export default Column;
